import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Slider from "react-slick";
import Badge from "@mui/material/Badge";

import DraggableDialog from "components/UpStyled/DraggableDialog";
import ChatRoom from "pages/messages/chatroom";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AvatarGroup from "@mui/material/AvatarGroup";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CopyrightIcon from "@mui/icons-material/Copyright";
import AddIcon from "@mui/icons-material/Add";
import FolderIcon from "@mui/icons-material/Folder";
import PublicIcon from "@mui/icons-material/Public";

import api from "services/api";
import { AccountContext } from "context/account";

import { toast } from "react-hot-toast";
import { socket } from "services/request";

import { privilegeOptions } from "utils/data";

import QuickShareChangeModal from "./QuickShareChangeModal";
import Prompt from "components/UpStyled/Prompt";
import ResourceOwner from "pages/de/share-page/components/ResourceOwner";
import AvatarComplex from "pages/de/share-page/components/AvatarComplex";

const SIZEMAP = {
  sm: 26,
  md: 32,
  lg: 36,
};

const SharedUserList = ({
  item = {},
  type,
  collaboratorUsers = [],
  size = "sm",
  onAvatarClick = null,
  handleAddCollaborator = null,
  sx = {},
  sharedSessions = null,
  handleRefresh = () => {},
  isOwner = false,
  ownerStore = {},
  maxAvatar = 5,
  handleAdditionalAvatarClick = null,
}) => {
  const [chatVisible, setChatVisible] = useState(false);
  const [currentRoom, setCurrentRoom] = useState(new Map());
  const [selectedUser, setSelectedUser] = useState({});
  const [menuVisible, setMenuVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({});
  const [shareVisible, setShareVisible] = useState(false);
  const [promptVisible, setPromptVisible] = useState(false);

  const account = useContext(AccountContext);

  const avatarSize = SIZEMAP[size] || 36;

  const handleDefaultAvatarClick = (e, user) => {
    if (isOwner) {
      setMousePosition({ clientX: e.clientX, clientY: e.clientY });
      setMenuVisible(true);
      setSelectedUser(user);
    } else {
      //open chat
      if (account?.id != user?.user_id && account?.id != user?.id) {
        retrieveChats(user?.user_id || user?.id);
        setChatVisible(true);
        setSelectedUser(user);
      }
    }
  };

  const retrieveChats = async (userId) => {
    if (!userId) {
      return;
    }
    try {
      const { data } = await api.chatroom.addChatRoom({
        userids: [userId],
      });
      setCurrentRoom(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCloseStyleImportMenu = () => setMenuVisible(false);

  const UserManagementMenu = () => (
    <Menu
      id="user-management-menu"
      open={menuVisible}
      onClose={handleCloseStyleImportMenu}
      anchorReference="anchorPosition"
      anchorPosition={{ top: mousePosition?.clientY + 4, left: mousePosition?.clientX + 4 }}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      sx={{ zIndex: 10000 }}
    >
      <MenuItem
        onClick={() => {
          if (selectedUser.user_id) {
            retrieveChats(selectedUser.user_id);
            setChatVisible(true);
          }
          handleCloseStyleImportMenu();
        }}
      >
        Chat
      </MenuItem>
      <MenuItem
        onClick={() => {
          if (selectedUser.resource_type != type) {
            if (selectedUser.resource_type == "collection") {
              setPromptVisible(true);
            } else {
              toast.error(`Can't change the permission, resource type is incompatible!`);
            }
          } else {
            setShareVisible(true);
          }
          handleCloseStyleImportMenu();
        }}
      >
        Change Permission
      </MenuItem>
    </Menu>
  );

  return (
    <SuiBox>
      <AvatarGroup
        max={maxAvatar ? maxAvatar : undefined}
        slotProps={{
          additionalAvatar: {
            sx: {
              width: avatarSize - 4,
              height: avatarSize - 4,
              fontSize: "12px",
              cursor: handleAdditionalAvatarClick ? "pointer" : "default",
            },
            className: "border",
            onClick: handleAdditionalAvatarClick ? handleAdditionalAvatarClick : null,
          },
        }}
        sx={{ pl: 2, display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        {isOwner && ownerStore?.id ? null : (
          <div>
            <AvatarComplex
              store={ownerStore}
              size="sm"
              onAvatarClick={
                onAvatarClick
                  ? (e) => onAvatarClick(e, ownerStore)
                  : (e) => handleDefaultAvatarClick(e, ownerStore)
              }
              sx={{
                cursor: "pointer",
                py: 0.5,

                "&:hover, &:focus": {
                  zIndex: "10",
                  px: 2,
                },
                ml: -1.5,
              }}
              sharedSessions={sharedSessions}
              tooltip={`${ownerStore?.name}${account?.id != ownerStore.id ? `(Owner)` : ""}`}
              iconColor="white"
              isOwner
            />
          </div>
        )}
        {collaboratorUsers.map((user, index) => {
          const store =
            user?.user?.stores && user?.user?.stores.length > 0 ? user?.user?.stores[0] : {};

          if (user?.user?.id == "AllDesigners") {
            return (
              <AvatarComplex
                user={user}
                size="sm"
                onAvatarClick={null}
                sx={{
                  cursor: "pointer",
                  py: 0.5,

                  "&:hover, &:focus": {
                    zIndex: "10",
                    pl: 2,
                    pr: 0,
                  },
                  ml: -1.5,
                }}
                tooltip={`${store?.name + "(All Designers)"}`}
                icon={<PublicIcon sx={{ height: 16, width: 16 }} color="warning" />}
                iconColor="white"
              />
            );
          }
          return (
            <div>
              <AvatarComplex
                user={user}
                size="sm"
                onAvatarClick={
                  onAvatarClick
                    ? (e) => onAvatarClick(e, user)
                    : (e) => handleDefaultAvatarClick(e, user)
                }
                sx={{
                  cursor: "pointer",
                  py: 0.5,

                  "&:hover, &:focus": {
                    zIndex: "10",
                    pl: 2,
                    pr: index == Math.min(maxAvatar, collaboratorUsers.length) - 1 ? 0 : 2,
                  },
                  ml: -1.5,
                }}
                sharedSessions={sharedSessions}
                tooltip={`${store?.name}${account?.id == store.id ? `(You)` : ""}`}
                icon={
                  user.resource_type == "collection" ? (
                    <FolderIcon sx={{ height: 16, width: 16 }} color="info" />
                  ) : (
                    ""
                  )
                }
                iconColor="white"
              />
            </div>
          );
        })}
      </AvatarGroup>
      <UserManagementMenu />
      {chatVisible ? (
        <DraggableDialog
          heading={`Chat with ${selectedUser?.user?.stores?.[0]?.name || selectedUser?.name}`}
          text={
            <SuiBox>
              <ChatRoom id={currentRoom?.id} />
            </SuiBox>
          }
          visible={chatVisible}
          hideAction={true}
          handleClose={() => {
            setChatVisible(false);
          }}
        />
      ) : null}
      {shareVisible ? (
        <QuickShareChangeModal
          item={item}
          user={selectedUser}
          type={type}
          visible={shareVisible}
          handleClose={() => setShareVisible(false)}
          handleRefresh={handleRefresh}
        />
      ) : null}
      {promptVisible && selectedUser ? (
        <Prompt
          heading="Change Permission"
          text={
            <SuiBox>
              This content is shared through a collection, please go{" "}
              {
                <Link to={`/workspace/collections?id=${selectedUser.resource_id}`}>
                  <strong>
                    <i>here</i>
                  </strong>
                </Link>
              }{" "}
              to change!
            </SuiBox>
          }
          visible={promptVisible}
          okText="Ok"
          handleOk={() => setPromptVisible(false)}
          handleClose={() => setPromptVisible(false)}
        />
      ) : null}
    </SuiBox>
  );
};

export default SharedUserList;
